import axios from "axios";
import { BASE_HEADLESS } from "./headless";

const PUBLIC_URL = BASE_HEADLESS;
/**
 * Creates a new user
 * @returns the newly created userId
 */
const getBackendInfo = async () => {
  const response = await axios.get(`${PUBLIC_URL}/api/service`);
  const result = {
    conv: response.data.conv as string | undefined,
    webapp: response.data.webapp as string | undefined,
  };
  if (result.conv && result.webapp) {
    return result;
  } else {
    throw new Error("No backend");
  }
};

export { getBackendInfo };
